import { createFileRoute } from '@tanstack/react-router';
import { MediaLibrary } from '@/components/media/media-library';

function SiteMedia() {
  const { orgId, siteId } = Route.useParams();

  return (
    <div className="flex flex-col gap-5">
      <div className="max-w-prose">
        <h2 className="text-lede font-semibold tracking-tight text-ink">Media</h2>
        <p className="text-data leading-relaxed text-ink-muted">
          Files this site's image and file fields point at. Each file is stored once, identified by
          its actual bytes rather than its extension, and stripped of embedded metadata such as GPS
          coordinates before it is saved.
        </p>
      </div>

      <MediaLibrary orgId={orgId} siteId={siteId} />
    </div>
  );
}

export const Route = createFileRoute('/app/$orgId/sites/$siteId/media')({
  component: SiteMedia,
});
